import _ from 'lodash'

/**
 * Boilerplate setup for a Print Operation tab.
 *
 * @example
 * import { tmrOperationBasePrintRoute } from 'tmr/routes/operations/print/print.route';
 *
 * export const route = tmrOperationBasePrintRoute({
 *   name: 'operations.print.productionOrderRows',
 *   label: 'OPERATIONS.PRINT.ORDERROWS.TITLE',
 *   url: '/print/orders',
 *   resourceType: 'ProductionOrderRow',
 *   resourceList: {
 *     searchParameters: ['printed']
 *   },
 *   component: 'tmrOperationPrintProductionOrderRows',
 *   accessControl: ['Operation.perform', 'Operation.Print.perform']
 * });
 */
export const tmrOperationBasePrintRoute = defaults =>
  _.defaultsDeep(defaults, {
    params: {
      printed: {
        value: 'false',
        squash: true,
      },
      resourcesToPrint: {
        value: [],
        dynamic: true,
      },
      searchAction: 'printablePagedQuery',
      countAction: 'printableCount',
    },
    mainMenu: false,
  })
